import { IntlCapitalTypeValues } from '@blockpulse3/data/locales/types';
import { CompanyCapitalType } from '@blockpulse3/graphql/hooks';

export const capitalTypeOptions: { label: IntlCapitalTypeValues; value: CompanyCapitalType }[] = [
  { label: 'FIXED', value: CompanyCapitalType.FIXED },
  { label: 'VARIABLE', value: CompanyCapitalType.VARIABLE },
];
